export default __webpack_public_path__ + "static/media/Renato's Crossbow.39f7e648.jpg";